var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useLayoutEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import cls from 'classnames';
var LazyImageStatus;
(function (LazyImageStatus) {
    LazyImageStatus["loading"] = "loading";
    LazyImageStatus["success"] = "success";
    LazyImageStatus["error"] = "error";
})(LazyImageStatus || (LazyImageStatus = {}));
export function LazyImage(_a) {
    var { className, src, onLoad, onError, fallbackIcon } = _a, props = __rest(_a, ["className", "src", "onLoad", "onError", "fallbackIcon"]);
    const [status, setStatus] = useState(LazyImageStatus.loading);
    const ref = useRef(null);
    const finalClassName = cls('WhSearch-LazyImage', className, {
        'WhSearch-LazyImage--loading': status === LazyImageStatus.loading,
        'WhSearch-LazyImage--ready': status === LazyImageStatus.success,
        'WhSearch-LazyImage--fallback': status === LazyImageStatus.error,
    });
    useLayoutEffect(() => {
        var _a, _b;
        if (!src) {
            setStatus(LazyImageStatus.error);
        }
        else if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.complete) {
            if (((_b = ref.current) === null || _b === void 0 ? void 0 : _b.naturalHeight) === 0) {
                setStatus(LazyImageStatus.error);
            }
            else {
                setStatus(LazyImageStatus.success);
            }
        }
        else {
            setStatus(LazyImageStatus.loading);
        }
    }, [src]);
    function load(event) {
        setStatus(LazyImageStatus.success);
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(event);
    }
    function fail(event) {
        setStatus(LazyImageStatus.error);
        onError === null || onError === void 0 ? void 0 : onError(event);
    }
    const icon = status === LazyImageStatus.error ? (React.createElement(FontAwesomeIcon, { className: "WhSearch-LazyImage__icon", icon: fallbackIcon || faExclamationTriangle })) : null;
    const image = src ? (React.createElement("img", Object.assign({ className: "WhSearch-LazyImage__image", alt: "", ref: ref, src: src, onLoad: load, onError: fail }, props))) : null;
    return (React.createElement("figure", { className: finalClassName },
        icon,
        image));
}
//# sourceMappingURL=LazyImage.js.map